import { Modal } from 'components/Modal';
import styles from './ResendBeneficiaryDocumentsModal.module.scss';

export const ResendBeneficiaryDocumentsModal = ({
  textNotification,
  setResendBeneficiaryDocumentsModal,
  resendBeneficiaryDocumentsModal,
}: {
  textNotification: string;
  setResendBeneficiaryDocumentsModal: (e: boolean) => void;
  resendBeneficiaryDocumentsModal: boolean;
}) => {
  return (
    <Modal
      setOpen={setResendBeneficiaryDocumentsModal}
      open={resendBeneficiaryDocumentsModal}>
      <div className={styles.root}>
        <p className={styles.title}>Статус документов</p>
        <p className={styles.info}>{textNotification}</p>
      </div>
    </Modal>
  );
};
